export { headingNodeName, headingLevelAttr } from './HeadingSpecs';
export var HeadingAction;
(function (HeadingAction) {
    HeadingAction["ToH1"] = "toH1";
    HeadingAction["ToH2"] = "toH2";
    HeadingAction["ToH3"] = "toH3";
    HeadingAction["ToH4"] = "toH4";
    HeadingAction["ToH5"] = "toH5";
    HeadingAction["ToH6"] = "toH6";
})(HeadingAction || (HeadingAction = {}));
